import { MbPopoverTrigger } from '@am/moebius';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  AdditionalCharge,
  AdditionalInformation,
  Breakdown,
} from '@core/models/breakdown/breakdown.interface';
import { HotelsService } from '@core/services/hotels.service';
import { UrlService } from '@services/url.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'am-pricing-popover',
  templateUrl: './pricing-popover.component.html',
  styleUrls: ['./pricing-popover.component.scss'],
})
export class PricingPopoverComponent implements OnInit, AfterViewInit {
  @ViewChild(MbPopoverTrigger, { static: true }) public popoverTaxes: MbPopoverTrigger;

  @Input() public rateId = '';
  @Input() public currencyCode = '';
  @Input() public fop = '';
  @Input() isArgentinian = false;

  public breakdown: Breakdown;
  public rate: any;
  public charges: AdditionalCharge[];
  public information: AdditionalInformation;
  private suscriptions!: Subscription;
  public isExpert = false;

  constructor(
    private hotelsService: HotelsService,
    private cdr: ChangeDetectorRef,
    private urlService: UrlService,
  ) {}

  public ngOnInit() {
    this.isExpert = this.urlService.isExperts();
  }

  public ngAfterViewInit() {
    this.cdr.detectChanges();
  }

  public getBreakdownHotel() {
    this.suscriptions = this.hotelsService
      .getHotelBreakdown(this.rateId, this.currencyCode)
      .subscribe((data) => {
        this.breakdown = data[0];

        if (this.breakdown !== undefined) {
          this.rate =
            this.fop === 'PAY_AT_DESTINATION'
              ? this.breakdown.price_clarification
              : this.breakdown.detail.rates[0];
          this.charges = this.breakdown.detail.charges;
          if (this.breakdown?.additional_information) {
            this.information = this.breakdown?.additional_information[0];
          }

          this.popoverTaxes.show();
          this.cdr.detectChanges();
          this.suscriptions.unsubscribe();
        }
      });
  }

  public hidden() {
    this.popoverTaxes.hide();
  }

  public showPop() {
    if (this.popoverTaxes && this.breakdown === undefined) {
      this.getBreakdownHotel();
    } else {
      this.popoverTaxes.show();
    }
  }
}
